// mds-dojo — dojo/dnd/Moveable (lite): makes a node draggable by pointer.
// Surface: new Moveable(node, { handle? }), events onMoveStart/onMove/onMoveStop
// (assignable), .destroy(). Position is applied as left/top like dojo's default
// mover. Enough for the legacy draggable panels (OccurrenceFM filters).

import dom from '../dom';

interface MoveableOptions {
  handle?: any;
}

class Moveable {
  node: HTMLElement;
  handle: HTMLElement;
  private _downHandler: (e: PointerEvent) => void;
  private _moveHandler: ((e: PointerEvent) => void) | null = null;
  private _upHandler: ((e: PointerEvent) => void) | null = null;

  constructor(node: any, params?: MoveableOptions) {
    this.node = dom.byId(node);
    this.handle = (params && params.handle && dom.byId(params.handle)) || this.node;
    this._downHandler = (e: PointerEvent) => this._onDown(e);
    this.handle.addEventListener('pointerdown', this._downHandler);
    if (!this.handle.style.cursor) { this.handle.style.cursor = 'move'; }
  }

  onMoveStart(_node: HTMLElement): void { /* assignable hook */ }
  onMove(_node: HTMLElement, _leftTop: { l: number; t: number }): void { /* assignable hook */ }
  onMoveStop(_node: HTMLElement): void { /* assignable hook */ }

  private _onDown(e: PointerEvent): void {
    if (e.button !== 0) { return; }
    const rect = this.node.getBoundingClientRect();
    const offX = e.clientX - rect.left;
    const offY = e.clientY - rect.top;
    const style = this.node.style;
    if (getComputedStyle(this.node).position === 'static') { style.position = 'absolute'; }
    this.onMoveStart(this.node);
    this._moveHandler = (me: PointerEvent) => {
      const l = me.clientX - offX;
      const t = me.clientY - offY;
      style.left = l + 'px';
      style.top = t + 'px';
      this.onMove(this.node, { l, t });
    };
    this._upHandler = () => {
      document.removeEventListener('pointermove', this._moveHandler!);
      document.removeEventListener('pointerup', this._upHandler!);
      this._moveHandler = null;
      this._upHandler = null;
      this.onMoveStop(this.node);
    };
    document.addEventListener('pointermove', this._moveHandler);
    document.addEventListener('pointerup', this._upHandler);
    e.preventDefault();
  }

  destroy(): void {
    this.handle.removeEventListener('pointerdown', this._downHandler);
    if (this._moveHandler) { document.removeEventListener('pointermove', this._moveHandler); }
    if (this._upHandler) { document.removeEventListener('pointerup', this._upHandler); }
  }
}

export default Moveable;
